import { useI18N } from "@sundae/react-hooks";
import { Notice, Text } from "@sundae/ui-toolkit";
import cx from "classnames";
import { FC, useMemo } from "react";
import TransactionSubmittingWrapper from "../../../../components/TransactionSubmittingWrapper";
import { useYieldFarmingPositionDialogContext } from "../../../../components/YieldFarmingComponents/PositionTable/context";
import { EOrderTransactionBuilderState } from "../../../../stores/OrderContext";

const SubmittingUpdatePosition: FC = () => {
  const { t } = useI18N("farms");
  const { transactionBuilderState } = useYieldFarmingPositionDialogContext();
  const isBuilding = useMemo(
    () => transactionBuilderState === EOrderTransactionBuilderState.BUILD,
    [transactionBuilderState]
  );

  return (
    <TransactionSubmittingWrapper>
      <Text
        className={cx("text-center", {
          "motion-safe:animate-slide-up": !isBuilding,
        })}
        tag="p"
      >
        {t(`portfolio.positions.tx.${isBuilding ? "building" : "submitting"}`)}
      </Text>
      <Notice className="mx-auto max-w-sm motion-safe:animate-slide-up" type="info" size="xs">
        {t(`transaction.${isBuilding ? "building" : "confirmInWallet"}`, { ns: "transactions" })}
      </Notice>
    </TransactionSubmittingWrapper>
  );
};

export default SubmittingUpdatePosition;
